import { TFunction } from "i18next";
import * as Yup from "yup";
export const CategoriesDishesValidationSchema = (t: TFunction) =>
    Yup.object({
        name: Yup.string().trim().required(t("validation.required")),
        comment: Yup.string().nullable(),
        iconId: Yup.number().nullable(),
    });
